import { render } from "./MarketingSettings.vue?vue&type=template&id=402feaa1&scoped=true&ts=true"
import script from "./MarketingSettings.vue?vue&type=script&lang=ts"
export * from "./MarketingSettings.vue?vue&type=script&lang=ts"

import "./MarketingSettings.vue?vue&type=style&index=0&id=402feaa1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402feaa1"]])

export default __exports__